import moment from 'moment';

export const validateAge = (value: string | null, minAge = 12): string | boolean => {
  const errorMessage = `The user must be ${minAge} years old at least`;

  if (!value) {
    return true;
  }

  return isDateLessMinAge(value, minAge) ? true : errorMessage;
};

export const isDateLessMinAge = (value: string, minAge: number): boolean =>
  moment(value) < moment().subtract(minAge, 'years');

export const validateMinAge = (value: string): string | boolean => validateAge(value);
